import { useEffect, useState } from "react";
import {
	Box,
	Container,
	Heading,
	Image,
	Link,
	SimpleGrid,
	Stack,
	Text,
} from "@chakra-ui/react";
import { useCmsApi } from "../../services/useCmsApi";
import { IPartner } from "../../models/ICmsModels";

const fallbackPartnerLogos = [
	{ name: "Gowan", image: "/partners/gowan_logo.png", href: "https://ca.gowanco.com/" },
	{ name: "Salford Group", image: "/partners/Salford_Logo_2021__RED.png", href: "https://salfordgroup.com/" },
	{ name: "Antara Agronomy Services", image: "/partners/Antara-Agronomy-Services-2021-Logo-Website-e1619643965971.png", href: "https://www.antaraag.ca/" },
	{ name: "Marc Hutlet Seeds", image: "/partners/marc_hutlet_seeds.png", href: "https://www.marchutletseeds.ca/" },
	{ name: "Nelson Motors", image: "/partners/nelson.png", href: "https://www.nelsonmotors.com/" },
	{ name: "GRDC", image: "/partners/Grdc_logo.png", href: "https://grdc.com.au/" },
	{ name: "EMILI", image: "/partners/EMILI-Slogan_BLUE-GREEN.webp", href: "https://emili.ca/" },
	{ name: "CENGN", image: "/CENGN_logo.png", href: "https://www.cengn.ca/" },
	{ name: "Protein Industries Canada", image: "/protein-industries-canada.png", href: "https://www.proteinindustriescanada.ca/" },
	{ name: "AIVA Network", image: "/partners/11_fa3a4b29-77fe-407a-a76c-a90c225ac833.png", href: "https://www.aivanetwork.ca/" },
];

export const PartnersSection = (): JSX.Element => {
	const cmsApi = useCmsApi();
	const [partnerLogos, setPartnerLogos] = useState(fallbackPartnerLogos);

	useEffect(() => {
		let cancelled = false;
		cmsApi.getPartners().then((items) => {
			if (!cancelled && items.length > 0) {
				const withLogos = items.filter((p): p is IPartner & { logoUrl: string } => !!p.logoUrl);
				if (withLogos.length > 0) {
					setPartnerLogos(withLogos.map((p) => ({
						name: p.name,
						image: p.logoUrl,
						href: p.websiteUrl || "#",
					})));
				}
			}
		}).catch(() => {});
		return () => { cancelled = true; };
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<Box bg="gray.50" py={{ base: "16", md: "24" }}>
			<Container maxW="1480px">
				<Stack
					maxW="1120px"
					mx="auto"
					w="full"
					spacing="6"
					color="gray.800"
					px={{ base: "1", md: "2" }}
				>
					<Heading size="md">For Partners</Heading>
					<Text fontSize={{ base: "md", md: "lg" }}>
						Are you a retailer, agronomy company, or agricultural service provider?
					</Text>
					<Text fontSize={{ base: "md", md: "lg" }}>
						Contact Geco to explore how weed intelligence can help you deliver greater value to your farm customers.
					</Text>
					<Text fontSize={{ base: "md", md: "lg" }}>
						We work with partners to develop solutions that fit their business model, customer relationships, and regional needs.
					</Text>
					<SimpleGrid
						columns={{ base: 2, sm: 3, md: 4, lg: 5 }}
						spacing={{ base: "4", md: "5" }}
						alignItems="center"
					>
						{partnerLogos.map((partner) => (
							<Link
								key={partner.name}
								href={partner.href}
								isExternal
								_hover={{ textDecoration: "none" }}
								display="flex"
								alignItems="center"
								justifyContent="center"
								bg="white"
								border="1px solid"
								borderColor="gray.200"
								borderRadius="lg"
								p={{ base: "3", md: "4" }}
								minH={{ base: "84px", md: "96px" }}
							>
								<Image
									src={partner.image}
									alt={partner.name}
									h={{ base: "42px", md: "50px" }}
									w="100%"
									objectFit="contain"
								/>
							</Link>
						))}
					</SimpleGrid>
				</Stack>
			</Container>
		</Box>
	);
};
